import type { WindowOpenOption } from "../types";

//TODO: add type generic type like in useTransitionNavigate
export const navigate = (url: string, options?: WindowOpenOption) => {
  const args: string[] = [url, options?._blank ? "_blank" : "_self"];
  window.open(...args);
};
